import axios from '@/request';
import qs from 'qs';

export default {
  async list(params: any) {
    return axios.get('shorturl/list', { params });
  },
  async add(params: any) {
    return axios.post('shorturl/add', qs.stringify(params));
  },
  async edit(params: any) {
    return axios.post('shorturl/edit', qs.stringify(params));
  },
  async detail(params: any) {
    return axios.get('shorturl/detail', { params });
  },
  async delete(params: any) {
    return axios.post('shorturl/delete', qs.stringify(params));
  },
  async logs(params: any) {
    return axios.get('shorturl/logs', { params });
  }
};
